import { NavigationButtonProps, NavigationButtons } from '@molecules/index';
import { MapComponent } from '@organisms/index';
import { addressResponseType } from '@utils';
import 'leaflet/dist/leaflet.css';
import { ErrorSummary, InlineErrorMessage, Label } from '@atoms/index';
import { AssetType, ErrorMessages } from '@types';
import { LatLngTuple } from 'leaflet';

export interface MapTemplateProps {
  id?: string;
  labelText: string;
  subText?: string | React.ReactNode;
  errorPath?: string;
  errorMessages: ErrorMessages[];
  onChangeAddress: (address: addressResponseType) => void;
  selectedAddress: addressResponseType;
  customAddressContent?: string | React.ReactNode;
  assetType?: AssetType | undefined;
  buttonNext: NavigationButtonProps;
  buttonPrevious: NavigationButtonProps;
  defaultLocation?: LatLngTuple;
}

export const MapTemplate = ({
  id,
  labelText,
  errorPath,
  errorMessages,
  onChangeAddress,
  selectedAddress,
  customAddressContent,
  assetType,
  buttonNext,
  buttonPrevious,
  subText = null,
  defaultLocation,
}: MapTemplateProps) => {
  return (
    <div className="lg:max-w-[80vw]">
      <ErrorSummary messages={errorMessages} />
      <div className="mt-4 flex flex-col gap-y-6">
        <Label
          className="!text-brand-primary !text-h2"
          htmlFor={errorPath ?? id}
          id={errorPath ?? id}
          text={labelText}
          isTitle={true}
        />
        {subText}
        <InlineErrorMessage path={errorPath} messages={errorMessages} />
        <MapComponent
          onChange={onChangeAddress}
          defaultLocation={defaultLocation}
          selectedAddress={selectedAddress}
          assetType={assetType}
          customAddressContent={customAddressContent}
        />
        <NavigationButtons
          buttonPrevious={buttonPrevious}
          buttonNext={buttonNext}
        />
      </div>
    </div>
  );
};
